import React, { useCallback, useContext } from 'react';
import { Helmet } from 'react-helmet';
import TriggerOverview from './TriggerOverview';
import { SidebarContext } from '../../../../context/SidebarContext';
import { useCompanySectionFilter } from '../../../../component/B2B/CompanySectionLayout';
import { fetchCompanyTriggerOverview } from './companyTriggerApi';

/** Company Trigger Trace → Overview. Scoping comes from the token and the toggle. */
const CTriggerOverview = () => {
  const { isB2BFansMode } = useContext(SidebarContext);
  const { department } = useCompanySectionFilter();

  const fetcher = useCallback(
    () => fetchCompanyTriggerOverview(department),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isB2BFansMode, department]
  );

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Trigger Trace | Shoorah</title>
      </Helmet>
      <TriggerOverview
        fetcher={fetcher}
        populationLabel={isB2BFansMode ? 'members' : 'employees'}
      />
    </div>
  );
};

export default CTriggerOverview;
